import { ZapFast } from "@untitledui/icons";
import { cx } from "@/utils/cx";

export const RuleSignalIcon = ({ className }: { className?: string }) => (
  <ZapFast className={cx("size-3.5 shrink-0", className)} aria-hidden />
);
